export default function Introduction() {
  return (
    <section id="pengenalan" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-moon-line"></i>
            Pengenalan Kempen
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 px-4">
            🌙 Pengenalan Kempen
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="relative">
            <div className="w-full h-64 sm:h-80 lg:h-96 rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/f92f3cffd83482855fe52d8386cb558e.png"
                alt="Kempen PBPKNM"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 w-20 h-20 sm:w-32 sm:h-32 bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl sm:rounded-3xl flex items-center justify-center shadow-xl">
              <i className="ri-gift-line text-3xl sm:text-5xl text-white"></i>
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Bersempena kedatangan bulan <strong className="text-emerald-700">Ramadhan Al-Mubarak</strong> dan sambutan <strong className="text-amber-600">Hari Raya Aidilfitri</strong>, Persatuan Bekas Pasukan Keselamatan Negara Malaysia (PBPKNM) melancarkan <strong>Kempen Infaq Bakul Makanan Ramadhan & Hari Raya</strong> bagi membantu ahli-ahli PBPKNM yang layak di seluruh Malaysia.
            </p>

            <div className="bg-gradient-to-r from-emerald-50 to-amber-50 rounded-2xl p-4 sm:p-6 border-l-4 border-emerald-600">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Kempen ini bertujuan meringankan beban kos sara hidup serta memastikan kebajikan bekas wira negara terus terpelihara, khususnya dalam menghadapi bulan ibadah dan perayaan.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 pt-4">
              <div className="bg-white rounded-xl p-4 sm:p-5 shadow-md border border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                  <i className="ri-map-pin-line text-xl sm:text-2xl text-emerald-600"></i>
                </div>
                <div className="text-xs sm:text-sm text-gray-500 mb-1">Liputan</div>
                <div className="text-sm sm:text-lg font-bold text-gray-800">Seluruh Malaysia</div>
              </div>
              <div className="bg-white rounded-xl p-4 sm:p-5 shadow-md border border-gray-100">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-2 sm:mb-3">
                  <i className="ri-shield-star-line text-xl sm:text-2xl text-amber-600"></i>
                </div>
                <div className="text-xs sm:text-sm text-gray-500 mb-1">Penerima</div>
                <div className="text-sm sm:text-lg font-bold text-gray-800">Ahli PBPKNM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
